
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { startSavingDescuento } from "../../../../services";

import Swal from "sweetalert2";
import dayjs from "dayjs";





export const FormCreateDescuento = () => {


    const { id, descuento } = useParams();
    const queryClient = useQueryClient();


    const [formLote, setFormLote] = useState({fecha: '', tipo:descuento, cantidad: ''})
    const { fecha, tipo, cantidad, observacion } = formLote;
    const handleChangeInput = ({ target }) => {
        setFormLote({...formLote,[target.name]: target.value});
    }



    const handleChangeFecha = (value) => {
        if (!value || !dayjs(value).isValid()) return;
        const withTime = dayjs(value).set('hour', dayjs().hour()).set('minute', dayjs().minute()).set('second', dayjs().second());
        setFormLote({ ...formLote, fecha:  withTime.toISOString() });
    };


    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([cantidad].includes('') ){
            return Swal.fire('Error', 'La cantidad es un campo obligatorio', 'error');
        }
        await Swal.fire({
            title: `Crear Descuento`,
            text: `¿Esta seguro de crear descuento?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Crear`
        }).then( async( _ ) => {
            const resp = await startSavingDescuento({...formLote, id});
            if(resp){
                setFormLote({fecha: null, tipo:descuento, cantidad: '', observacion: ''}); 
                queryClient.invalidateQueries({queryKey: ['descuento-tipo']});
            }
        });
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12}>
                    <TextField required
                        disabled={true}
                        label='Descuento'
                        type='Text'
                        placeholder='Descuento'
                        fullWidth
                        name='tipo'
                        value={ tipo }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField required
                        label='Cantidad'
                        type='Number'
                        placeholder='Cantidad'
                        fullWidth
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleChangeInput }
                    />
                </Grid>


                 {/* <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Fecha"
                                    value={formValues.fecha || null}
                                    onChange={ handleChangeFecha }
                                    renderInput={ (params) => <TextField {...params} fullWidth size='small' /> }
                                />
                            </LocalizationProvider>
                        </Grid> */}

                <Grid item xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha"
                            value={fecha || null}
                            onChange={ handleChangeFecha }
                            renderInput={ (params) => <TextField {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>


                <Grid item xs={12}>
                    <TextField
                        label='Observación'
                        type='Text'
                        placeholder='Observación'
                        fullWidth
                        name='observacion'
                        value={ observacion }
                        onChange={ handleChangeInput }
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        Crear Descuento
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
